export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Financial Services.19042f28.PNG";